import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

// export const reportTypes = {
//     sales: "sales_report",
//     // salesItem: "sales_item_report",
//     delivery: "delivery_report",
//     // deliveryItem: "delivery_item_report",
//     retailPrescription: "retail_prescription_report",
//     retailCashSales: "retail_cash_sales_report",
//     itemReceive: "item_receive_report"
// }

export const reportScopes = {
    product: "product",
    sales: "sales",
    warehouse: "warehouse",
    inventory: "inventory",
    other: "other"
}

export const reportTypes = {
    product: {
        productItem: {
            id: "productItem",
            display: "productItemReport",
            key: "item_report"
        },
    },
    sales: {
        salesOrder: {
            id: "salesOrder",
            display: "salesOrderReport",
            key: "sales_report"
        },
        salesOrderItem: {
            id: "salesOrderItem",
            display: "salesOrderItemReport",
            key: "sales_item_report"
        },
        deliveryOrder: {
            id: "deliveryOrder",
            display: "deliveryOrderReport",
            key: "delivery_report"
        },
        deliveryOrderItem: {
            id: "deliveryOrderItem",
            display: "deliveryOrderItemReport",
            key: "delivery_item_report"
        },
        // retailCashSales: {
        //     id: "retailCashSales",
        //     display: "retailCashSalesReport",
        //     key: "retail_cash_sales_report"
        // }
    },
    warehouse: {
        itemReceive: {
            id: "itemReceive",
            display: "itemReceiveReport",
            key: "item_receive_report"
        },
        itemReceiveItem: {
            id: "itemReceiveItem",
            display: "itemReceiveItemReport",
            key: "item_receive_item_report"
        },
        itemTransfer: {
            id: "itemTransfer",
            display: "itemTransferReport",
            key: "item_transfer_report"
        },
        itemTransferItem: {
            id: "itemTransferItem",
            display: "itemTransferItemReport",
            key: "item_transfer_item_report"
        }
    },
    inventory: {
        stockValue: {
            id: "stockValue",
            display: "stockValueReport",
            key: "inventory_report"
        }
    },
    other: {
        // retailPrescription: {
        //     id: "retailPrescription",
        //     display: "retailPrescriptionReport",
        //     key: "retail_prescription_report"
        // },
    }
}

export function useReports({
    reportScope: _reportScope = '',
    reportType: _reportType = ''
}) {

    const [reportScope, setReportScope] = useState(_reportScope);
    const [reportType, setReportType] = useState(_reportType);
    // const [ scopeType, setScopeType ] = useState();

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "reports";
    // const endpoint2 = "rack";
    // const endpoint3 = "location/rack";

    const list = async (props) => {

        setIsLoading(true);

        let reportKey = reportTypes[reportScope][reportType].key

        try {

            let endpointUrl = `${endpoint}/${reportKey}`

            const url = getListsUrl(endpointUrl, props);

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        reportTypes,
        list,
    }
}